import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { createScopedKeydownHandler } from "./auth-service-tools180.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { useDirection } from "./auth-service-tools250.js";
import { UnstyledButton } from "./auth-service-tools258.js";
import { useTabsContext } from "./auth-service-tools412.js";
import classes from "./auth-service-tools416.js";
const defaultProps = {};
const TabsTab = factory((_props, ref) => {
  const props = useProps("TabsTab", defaultProps, _props);
  const {
    className,
    children,
    rightSection,
    leftSection,
    value,
    onClick,
    onKeyDown,
    disabled,
    color,
    style,
    classNames,
    styles,
    vars,
    mod,
    tabIndex,
    ...others
  } = props;
  const theme = useMantineTheme();
  const {
    dir
  } = useDirection();
  const ctx = useTabsContext();
  const active = value === ctx.value;

  const activateTab = event => {
    ctx.onChange(ctx.allowTabDeactivation ? value === ctx.value ? null : value : value);
    onClick == null ? void 0 : onClick(event);
  };

  const stylesApiProps = {
    classNames,
    styles,
    props
  };
  return /* @__PURE__ */jsxRuntimeExports.jsxs(UnstyledButton, { ...others,
    ...ctx.getStyles("tab", {
      className,
      style,
      variant: ctx.variant,
      ...stylesApiProps
    }),
    disabled,
    unstyled: ctx.unstyled,
    variant: ctx.variant,
    mod: [{
      active,
      disabled,
      orientation: ctx.orientation,
      inverted: ctx.inverted,
      placement: ctx.orientation === "vertical" && ctx.placement
    }, mod],
    ref,
    role: "tab",
    id: ctx.getTabId(value),
    "aria-selected": active,
    tabIndex: tabIndex || active || ctx.value === null ? 0 : -1,
    "aria-controls": ctx.getPanelId(value),
    onClick: activateTab,
    __vars: {
      "--tabs-color": color ? getThemeColor(color, theme) : void 0
    },
    onKeyDown: createScopedKeydownHandler({
      siblingSelector: '[role="tab"]',
      parentSelector: '[role="tablist"]',
      activateOnFocus: ctx.activateTabWithKeyboard,
      loop: ctx.loop,
      orientation: ctx.orientation || "horizontal",
      dir,
      onKeyDown
    }),
    children: [leftSection && /* @__PURE__ */jsxRuntimeExports.jsx("span", { ...ctx.getStyles("tabSection", stylesApiProps),
      "data-position": "left",
      children: leftSection
    }), children && /* @__PURE__ */jsxRuntimeExports.jsx("span", { ...ctx.getStyles("tabLabel", stylesApiProps),
      children
    }), rightSection && /* @__PURE__ */jsxRuntimeExports.jsx("span", { ...ctx.getStyles("tabSection", stylesApiProps),
      "data-position": "right",
      children: rightSection
    })]
  });
});
TabsTab.classes = classes;
TabsTab.displayName = "@mantine/core/TabsTab";
export { TabsTab };